import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { filterDefined } from '@recruitee/common';

import { DevFlagSelectors } from './store/dev-flags.store';
import type { DevFlagsMap } from './types';
import { DevFlag } from './types';

const initialState: DevFlagsMap = Object.values(DevFlag).reduce(
  (acc, curr) => {
    acc[curr] = false;
    return acc;
  },
  <DevFlagsMap>{},
);

export const injectDevFlagsMap = () => {
  let map: DevFlagsMap = initialState;
  inject(Store)
    .select(DevFlagSelectors.data)
    .pipe(filterDefined, take(1))
    .subscribe(data => {
      map = data;
    });
  return map;
};

export const injectDevFlag = (flag: DevFlag) => {
  let isEnabled = false;
  inject(Store)
    .select(DevFlagSelectors.isEnabled(flag))
    .pipe(take(1))
    .subscribe(data => {
      isEnabled = data;
    });
  return isEnabled;
};
